import React from 'react';
import { useParams } from 'react-router-dom';

export default function LessonPage() {
  const { lessonId } = useParams();

  const lessonSrc = `/lessons/lesson-${lessonId}.html`;

  return (
    <div style={styles.page}>
      <iframe
        title={`lesson-${lessonId}`}
        src={lessonSrc}
        style={styles.iframe}
      />
    </div>
  );
}

const styles = {
  page: {
    minHeight: 'calc(100vh - 76px)',
    background: '#F7F6F4',
  },

  iframe: {
    display: 'block',
    width: '100%',
    height: 'calc(100vh - 76px)', // 🔥 header만 제외
    border: 'none',
    background: '#FFFFFF',
  },
};